/**
 * @author      Holger Schauf
 * @title       Tipo Tooltips
 * @type        extention module
 * @requires    jquery.tooltip.core.js
 * @description set default desktop events, apperience and behaviors
 */

Tipo.prototype.setEvents = function (self) {
    self.id = new Date().getTime();
    window.openDelay = false;

    if (self.cfg.sticky === true) {
        self.sticky = true;
        self.elm.on('click', function () {
            self.toggle();
            return false;
        });
    } else {
        if (typeof self.elm.attr('tipo') === 'undefined') {
            self.elm.on(
                'hover',
                function () {
                    window.openDelay = window.setTimeout(function () {
                        self.showTooltip(self);
                    }, self.cfg.openDelay);
                },
                function () {
                    if (self.cfg.closeDelay !== false) {
                        if (window.openDelay === false) {
                            window.preventer = window.setTimeout(function () {
                                if (self.sticky === false) {
                                    self.hideTooltip(self);
                                }
                            }, self.cfg.closeDelay * 1000);
                        } else {
                            clearTimeout(window.openDelay);
                        }
                    } else {
                        if (window.openDelay === false) {
                            clearTimeout(window.instantPrevent);
                            self.sticky = false;
                            self.hideTooltip(self);
                        } else {
                            clearTimeout(window.openDelay);
                        }
                    }
                }
            );
        } else {
            self.elm.on({
                'mouseenter.tipo': function () {
                    if (!self.elm.attr('tipo')) {
                        return;
                    }
                    window.openDelay = window.setTimeout(function () {
                        self.showTooltip(self);
                    }, self.cfg.openDelay);
                },
                'mouseleave.tipo': function () {
                    if (self.cfg.closeDelay !== false) {
                        if (window.openDelay === false) {
                            window.preventer = window.setTimeout(function () {
                                if (self.sticky === false) {
                                    self.hideTooltip(self);
                                }
                            }, self.cfg.closeDelay * 1000);
                        } else {
                            clearTimeout(window.openDelay);
                        }
                    } else {
                        if (window.openDelay === false) {
                            clearTimeout(window.instantPrevent);
                            self.sticky = false;
                            self.hideTooltip(self);
                        } else {
                            clearTimeout(window.openDelay);
                        }
                    }
                },
            });
        }
        // prevent click on empty or # href
        self.preventClick(self.elm);
    }

    // bind check event to element
    self.elm.on('tipRefresh', function () {
        self.refresh(self);
    });

    // bind timed show event to element
    self.elm.on('tipShow', function () {
        self.showTooltip(self);
        self.hideAfterSeconds(self, 11);
    });
};

Tipo.prototype.refresh = function (self) {
    self.buildTip(self);
    self.setPosition(self);
    self.resetEvent(self);
    $('#' + self.id).html(self.tip.html());
};

Tipo.prototype.buildTip = function (self) {
    if (false === self.source(self)) {
        return false;
    }

    var close =
        self.cfg.closeButton === true
            ? '<a id="close" class="' + self.cfg.position + '"></a>'
            : '';

    var arrow = '';

    if (self.cfg.arrow === true) {
        if (self.cfg.arrowTop > 0) {
            arrow =
                '<span id="arrow" style="top: ' +
                self.cfg.arrowTop +
                'px;"></span>';
        } else if (self.cfg.arrowLeft > 0) {
            arrow =
                '<span id="arrow" style="left: ' +
                self.cfg.arrowLeft +
                'px;"></span>';
        } else {
            arrow = '<span id="arrow"></span>';
        }
    }

    if (self.cfg.tmpl !== false && typeof $.tmpl !== 'undefined') {
        if ($('#' + self.cfg.tmpl).length > 0) {
            self.content = $.tmpl($('#' + self.cfg.tmpl), self.cfg.data).html();
        }
    }

    if (self.cfg.sticky === true || self.cfg.closeButton === true) {
        self.cfg.addClass =
            tipoDefaultClasses + ' ' + self.cfg.addClass + ' sticky';
    }

    var type = self.cfg.type !== 'false' ? self.cfg.type : '';

    self.tip = $(
        '<div id="' +
            self.id +
            '" class="cf tooltip ' +
            type +
            ' ' +
            tipoDefaultClasses +
            ' ' +
            self.cfg.addClass +
            '">' +
            close +
            arrow +
            self.content +
            '</div>'
    );

    if (self.cfg.closeDelay !== false) {
        $(document).on(
            {
                mouseleave: function () {
                    window.sticky = false;
                    window.setTimeout('' + self.hideTooltip(self) + '', 70);
                },
            },
            '.tooltip'
        );
    }

    self.postBuildHook();
};

Tipo.prototype.setPosition = function (self) {
    if (self.cfg.width > 0) {
        self.tip.css({
            width: self.cfg.width,
        });
    }
    self.inArea(self);

    // get Position of trigger Element
    var pos = Object.assign({}, self.elm.offset(), {
        width: self.elm.outerWidth(true),
        height: self.elm.outerHeight(true),
    });

    var tipWidth = self.tip.outerWidth(true);
    var elHeight = self.elm.height();
    var windowHeight = $(window).height();
    var cfgTop = parseInt(self.cfg.top, 10);
    var cfgMargin = parseInt(self.cfg.margin, 10);
    var cfgLeft = parseInt(self.cfg.left, 10);
    var cfgLeftMargin = parseInt(self.cfg.leftMargin, 10);
    var cfgRightMargin = parseInt(self.cfg.rightMargin, 10);
    var offsetTop = self.elm.offset().top;
    var scrollTop = $(document).scrollTop();
    var outerHeight = self.tip.outerHeight(true);

    if (self.avoidPos === 'bottom') {
        self.tip.css({
            top: pos.top + elHeight + cfgMargin + cfgTop,
            left:
                pos.left +
                pos.width / 2 -
                tipWidth / 2 +
                cfgLeftMargin -
                cfgRightMargin,
        });
    } else if (self.avoidPos === 'left') {
        self.tip.css({
            top: pos.top + pos.height / 2 - 18 + cfgTop,
            left: pos.left - tipWidth - cfgMargin + cfgLeft,
        });
    } else if (self.avoidPos === 'right') {
        self.tip.css({
            top: pos.top + pos.height / 2 - 18 + cfgTop,
            left: pos.left + pos.width + cfgMargin + cfgLeft,
        });
    } else if (self.avoidPos === 'leftbottom') {
        self.tip.css({
            top: pos.top + elHeight + parseInt(self.cfg.topMargin, 10) + cfgTop,
            left: pos.left + pos.width - tipWidth - cfgMargin,
        });

        //new temp positions if tip outside view
    } else if (self.avoidPos === 'top') {
        self.tip.css({
            top: pos.top - outerHeight - cfgMargin,
            left:
                pos.left +
                pos.width / 2 -
                tipWidth / 2 +
                cfgLeftMargin -
                cfgRightMargin,
        });
    } else if (self.avoidPos === 'leftspecial') {
        self.tip.css({
            top:
                offsetTop -
                (offsetTop - scrollTop + outerHeight - windowHeight) -
                12,
            left: pos.left - tipWidth - 10 + cfgLeft,
        });
    } else if (self.avoidPos === 'rightnew') {
        self.tip.css({
            top:
                offsetTop -
                (offsetTop - scrollTop + outerHeight - windowHeight),
            left: pos.left + pos.width + cfgMargin + cfgLeft,
        });
    } else if (self.avoidPos === 'leftnew') {
        self.tip.css({
            top:
                offsetTop -
                (offsetTop - scrollTop + outerHeight - windowHeight),
            left: pos.left - tipWidth - cfgMargin + cfgLeft,
        });
    }

    //set new temp position for arrow
    var temparrow = self.tip.find('#arrow');
    temparrow.attr('class', self.avoidPos);

    self.tip.addClass(self.avoidPos);

    if (
        self.avoidPos === 'leftspecial' ||
        self.avoidPos === 'rightnew' ||
        self.avoidPos === 'leftnew'
    ) {
        var arrowCssTop = offsetTop - parseInt(self.tip.css('top'));
        temparrow.css({
            top: arrowCssTop,
        });
    } else {
        if (!self.cfg.allowArrowStyle) {
            temparrow.attr('style', '');
        }
    }

    self.tip.show();
};

Tipo.prototype.inArea = function (self) {
    var windowHeight = $(window).height();
    var maxOuter =
        $(self.elm).offset().top -
        $(document).scrollTop() +
        $('#' + self.id).outerHeight(true);

    if (self.cfg.position === 'bottom') {
        maxOuter += 50;
    }

    if (windowHeight < maxOuter) {
        if (self.cfg.position === 'bottom') {
            self.avoidPos = 'top';
        } else if (self.cfg.position === 'right') {
            self.avoidPos = 'rightnew';
        } else if (self.cfg.position === 'left') {
            self.avoidPos = 'leftnew';
        } else if (self.cfg.position === 'leftbottom') {
            self.avoidPos = 'leftspecial';
        }
    } else {
        self.avoidPos = self.cfg.position;
    }
};

Tipo.prototype.showTooltip = function (self) {
    if ($(self.tip).is(':visible')) {
        return false;
    }

    if (self.elm.hasClass('dont-show-tooltip')) {
        return;
    }

    tipoList[self.id] = self;

    var $tooltip = $('.tooltip');

    if (mobile) {
        $tooltip.remove();
    } else {
        if ($tooltip.is(':visible')) {
            self.hideTooltip(self);
        } else {
            window.preventer = false;
            window.openDelay = false;
        }
    }

    if (window.preventer !== false) {
        clearTimeout(window.preventer);
    }

    if (self.elm.parents('.tooltip').length > 0) {
        $tooltip
            .not('#' + self.elm.parents('.tooltip').attr('id'))
            .not('#' + self.id)
            .remove();
    } else {
        $tooltip.not('#' + self.id).remove();
    }

    if (self.tip === null) {
        self.buildTip(self);
    }

    if (self.body.length === 0) {
        self.body = $('body');
    }

    if (self.tip !== null) {
        self.body.append(self.tip);

        self.openTime = Date.now();

        self.setPosition(self);


        self.resetEvent(self);

        self.checkCallback();

        if (self.cfg.closeDelay !== false) {
            self.preventEvent(self);
        }
    }
};

Tipo.prototype.getBackgroundElement = function (self) {
    var result = $('#tooltipBehindBackground');

    if (result.length) {
        return result;
    }

    return $(
        '<div id="tooltipBehindBackground" class="tooltip-behind-background"><svg class="tooltip-behind-background"></svg></div>'
    )
        .insertBefore(self.tip)
        .css({ opacity: 0 });
};

Tipo.prototype.checkCallback = function () {
    if (this.cfg.callback === false) return false;

    if (this.cfg.callback === 'function') return this.cfg.callback(self.tip);

    var classPath = this.cfg.callback.split('.');

    var winSearch = window;

    for (var i = 0; i < classPath.length; i++)
        winSearch = winSearch[classPath[i]];

    try {
        winSearch(this.tip);
    } catch (e) {
        console.log('no callback found: ' + e);
    }
};

Tipo.prototype.resetEvent = function (self) {
    if (self.cfg.sticky === true) {
        self.sticky = true;

        $('.tooltip').on('outerclick', function () {
            self.sticky = false;
            self.hideTooltip(self);
            return false;
        });
    }

    if (self.cfg.closeButton === true) {
        $('#' + self.id)
            .find('#close')
            .on('click', function () {
                self.hideTooltip(self);
                return false;
            });
    }
};

Tipo.prototype.preventClick = function (elm) {
    if (
        elm.attr('href') !== undefined &&
        (elm.attr('href') === '#' || elm.attr('href') === '')
    ) {
        elm.on('click', function (e) {
            e.preventDefault();
        });
    }
};

Tipo.prototype.preventEvent = function (self) {
    $('.tooltip').on('mouseenter', function () {
        self.sticky = true;
        clearTimeout(next);
    });
};
